<template>
  <div class="pre-loader">
    <div id="preloader" v-if="$store.state.loading_state"></div>
  </div>
</template>

<script>
export default {
  name: "pre-loader",
};
</script>
